import { Box, Button, Stack, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import AddCardIcon from '@mui/icons-material/AddCard'
import CategoryIcon from '@mui/icons-material/Category'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

function FinanceEmptyShortcut() {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  return (
    <Stack
      className="no-drag"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      spacing={1.5}
      sx={{
        height: '100%',
        minHeight: 260,
        px: 2,
        color: 'white',
      }}
    >
      <Box
        sx={{
          width: 58,
          height: 58,
          borderRadius: 2,
          display: 'grid',
          placeItems: 'center',
          bgcolor: 'rgba(255, 255, 255, 0.1)',
          border: '1px solid rgba(255, 255, 255, 0.16)',
          color: '#c1daf1',
        }}
      >
        <AddCardIcon sx={{ fontSize: 31 }} />
      </Box>
      <Typography sx={{ fontWeight: 850, fontSize: 19, lineHeight: 1.2 }}>
        {t('finance.fiStatement.emptyTitle')}
      </Typography>
      <Typography sx={{ maxWidth: 340, color: 'rgba(255, 255, 255, 0.72)', fontSize: 13.5 }}>
        {t('finance.fiStatement.emptyHint')}
      </Typography>
      <Stack direction="row" gap={1} flexWrap="wrap" justifyContent="center">
        <Button
          component={RouterLink}
          to="/gestionoperations"
          variant="contained"
          startIcon={<AddCardIcon />}
          sx={{
            bgcolor: '#1b75d0',
            borderRadius: 999,
            px: 2,
            py: 0.8,
            fontWeight: 800,
            textTransform: 'none',
            '&:hover': { bgcolor: '#145da8' },
          }}
        >
          {t('finance.fiStatement.createOperationsBtn')}
        </Button>
        <Button
          component={RouterLink}
          to="/categorisation"
          variant="outlined"
          startIcon={<CategoryIcon />}
          sx={{
            borderColor: 'rgba(193, 218, 241, 0.55)',
            color: '#ffffff',
            borderRadius: 999,
            px: 2,
            py: 0.8,
            fontWeight: 800,
            textTransform: 'none',
            '&:hover': {
              borderColor: '#c1daf1',
              bgcolor: 'rgba(193, 218, 241, 0.08)',
            },
          }}
        >
          {t('finance.fiStatement.categorizeBtn')}
        </Button>
      </Stack>
    </Stack>
  )
}

export default FinanceEmptyShortcut
